<template lang="pug">
div.container
  md-layout(md-column, md-flex='40')
    md-theme.table(md-name='blue', v-if="videos.length > 0")
      md-card.md-table-card.content-table.hidden(v-if='rowsHidden')
        label.align-center Uploading {{ this.videos.length }} videos 
        md-button.hide-show-table(@click='hideShowRows')
          md-icon(md-iconset='fa fa-arrow-circle-down')
      md-card.content-table(v-else)
        div.titleLine.styleRow
          p.rowElements Name
          p.rowElements Status
          p.rowElements Progress
          md-button.hide-show-table(@click='hideShowRows')
            md-icon(md-iconset='fa fa-arrow-circle-up')
        div#rowVideos.styleRow(v-for='video in videos', :key='video.name')
          div.rowElements {{ getShortName(video.name) }}
          div.rowElements(v-if="video.progress === '100'") completed
          div.rowElements(v-else) {{ video.status }}
          div.rowElements  {{ video.progress }} {{video.progress !== 'errored' ? '%' : ''}}
          md-button.md-icon-button.md-raised.icon-center(v-on="video.progress ===  'errored' || video.progress === '100' ? {click: () => deleteVideo(video.name)} : {} ")
            md-icon(:md-iconset="video.progress === '100' ? 'fa fa-check' : video.progress === 'errored' ? 'fa fa-trash-alt' : 'fa fa-spinner fa-spin '")
</template>

<script>

export default {
  components: {},
  data() {
    return {
      videos: [],
      rowsHidden: false,
      uploadinIcon: 'fa fa-spinner',
    };

  },
  methods: {
    getShortName(name) {
      return name.substring('videoupload'.length + 3)
    },

    displayVideo() {
      this.checkLocalStorage().then((data) => {
        this.videos = data
        if (data.length === 0) {
          this.$emit('showVideoUploading', false);
        } else {
          this.$emit('showVideoUploading', true);
        }
      })
    },
    checkLocalStorage() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const videoNamesArray = Object.keys(localStorage).filter((key) => {
            if (key.split("-")[0] === 'videoupload') {
              return key;
            }
          });

          const videoArray = videoNamesArray.map((videoName) => {
            return ({ name: videoName, status: 'uploading', progress: localStorage.getItem(videoName) });
          })

          resolve(videoArray);
        }, 500);
      });
    },
    deleteVideo(name) {
      const deletePromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          const videos = JSON.parse(JSON.stringify(this.videos))
          const videosArray = videos.filter(function (ele) {
            localStorage.removeItem(name);
            return ele.name != name;
          })
          resolve(videosArray);
        }, 500);
      });

      deletePromise.then((videos) => {
        this.videos = videos;
      })
    },
    hideShowRows() {
      this.rowsHidden = !this.rowsHidden
    },
  },
  mounted() {
    setInterval(this.displayVideo, 5000);
  }
};
</script>

<style>
.container {
  position: fixed;
  z-index: 9998 !important;
  bottom: 0;
  margin-bottom: 90px;
}

.on-left {
  margin-top: -5px;
  margin-right: 5px;
}

.content-table {
  margin: 25px 10%;
  border-radius: 10px;
  box-shadow: 5px 5px 45px 1px rgba(0, 0, 0, 0.4);

  @media (max-width: 945px) {
    margin-left: 5px;
    margin-right: 5px;
  }
}

.hide-show-table {
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 0px;
}

.rowStyle {
  visibility: visible
}

.hidden {
  width: 150px;
  background-color: rgb(214, 214, 219) !important;
  border-radius: 5px;
}

.align-center {
  text-align: center;
  float: right;
}

.icon-center {
  margin-left: 18px !important;
}

#rowVideos:hover {
  background-color: rgba(188, 194, 194, 0.209) !important;
}

.styleRow {
  display: flex;
  align-items: center;
  padding: 0.3rem;
  text-align: center;
}

.styleRow p {
  font-weight: 600;
}

.rowElements {
  width: 9rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.titleLine {
  border-bottom: solid;
  border-bottom-width: 1px;
  border-bottom-color: rgba(153, 155, 155, 0.486);
}
</style>




// WEBPACK FOOTER //
// src/spa/mediaItem/MediaItemUploading.vue